import React from 'react';
import Button from 'components/Button/Button';
import styles from './SessionModal.css';
import classNames from 'classnames';

export const SessionCountDown = (props) => {
  const minutes = Math.floor(props.timeLeft / 60);
  const seconds = props.timeLeft % 60;

  return (
    <div className={styles.modalDialog}>
      <div className={styles.modalContent}>
        <h2>Your session will end soon</h2>

        <div className={styles.modalBody}>
          <p>
            For security reasons, you will be logged out in {minutes}:
            {seconds.toString().padStart(2, '0')}{' '}
            {props.timeLeft < 60 ? 'second/s' : 'minute/s'}. Select
            &apos;Continue&apos; to stay signed in.
          </p>
        </div>

        <div className={styles.modalFooter}>
          <Button
            onClick={() => props.onLogout({ showContinueSession: false })}
            theme='linkButtonTheme'
            className={styles.logoutBtn}
            disabled={props.isLoading}
          >
            Log out
          </Button>

          <Button
            onClick={props.onContinue}
            className={classNames('brandColor__button', styles.blockBtn)}
            theme='buttonNext'
            disabled={props.isLoading}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
